import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-V8FqlKqe.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--ar-AE" */'./ar-AE-Cju_EVR7.js'),
  'de-DE': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--de-DE" */'./de-DE-CTchNMtq.js'),
  'en-AU': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--en-AU" */'./en-AU-CFpf5lpo.js'),
  'en-CA': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--en-CA" */'./en-CA-DYQHKawd.js'),
  'en-GB': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--en-GB" */'./en-GB-BOrqVZcX.js'),
  'en-IN': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--en-IN" */'./en-IN-BGXuV--n.js'),
  'en-SG': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--en-SG" */'./en-SG-BhksYqVP.js'),
  'es-CO': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--es-CO" */'./es-CO-DkiaNT9t.js'),
  'es-ES': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--es-ES" */'./es-ES-BdHYBTXM.js'),
  'es-MX': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--es-MX" */'./es-MX-DDRWJVBN.js'),
  'fr-CA': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--fr-CA" */'./fr-CA-KjByw1nx.js'),
  'fr-FR': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--fr-FR" */'./fr-FR-85Ce3xvb.js'),
  'hi-IN': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--hi-IN" */'./hi-IN-CDlRyALF.js'),
  'it-IT': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--it-IT" */'./it-IT-DcAc8VLg.js'),
  'ja-JP': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--ja-JP" */'./ja-JP-D6kfSOXf.js'),
  'ko-KR': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--ko-KR" */'./ko-KR-Bm7gbLHN.js'),
  'nl-NL': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--nl-NL" */'./nl-NL-CZos56Wl.js'),
  'pl-PL': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--pl-PL" */'./pl-PL-C-fHQ-Jd.js'),
  'pt-BR': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--pt-BR" */'./pt-BR-BUUdhquV.js'),
  'sv-SE': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--sv-SE" */'./sv-SE-DCQ2stJY.js'),
  'ta-IN': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--ta-IN" */'./ta-IN-BjSagiqF.js'),
  'th-TH': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--th-TH" */'./th-TH-DSvEb3ba.js'),
  'tr-TR': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--tr-TR" */'./tr-TR-CTdTtcgk.js'),
  'vi-VN': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--vi-VN" */'./vi-VN-CnQ_51oG.js'),
  'zh-CN': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--zh-CN" */'./zh-CN-ZohxZu97.js'),
  'zh-TW': () => import(/* webpackChunkName: "storm-ui--AbandonmentDialog--zh-TW" */'./zh-TW-DZDE261y.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-BzSLd1UN.js.map
